module.exports = __webpack_public_path__ + "static/media/1.44fcfcc4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/1.svg
// module id = 70
// module chunks = 0